import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "h-100 d-flex flex-column" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "overflow-hidden d-flex" }
const _hoisted_5 = ["id"]
const _hoisted_6 = ["id"]
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "overflow-hidden",
      id: _ctx.timelineContainerId
    }, [
      _createElementVNode("div", { id: _ctx.timelineId }, null, 8, _hoisted_3)
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "flex-grow-0 flex-shrink-1",
        id: _ctx.tableId
      }, null, 8, _hoisted_5),
      _createElementVNode("div", {
        class: "overflow-auto",
        id: _ctx.chartId,
        onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollHeatmap && _ctx.scrollHeatmap(...args)))
      }, null, 40, _hoisted_6)
    ]),
    (!_ctx.isMxGraphSupported())
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Charts are not supported by current browser "))
      : _createCommentVNode("", true)
  ]))
}